module.exports = __webpack_public_path__ + "img/img_mission_us@3x.5db24cf3.png";